import Hero from './Hero';
import ItemList from '../../common/utils/ItemList';
import listItems from '../../common/helpers/listItems';
export default class DiscussionHero extends Hero {
  className() {
    return 'DiscussionHero';
  }
  bodyItems() {
    const items = new ItemList();
    items.add('items', m("ul", {
      className: "DiscussionHero-items"
    }, listItems(this.items().toArray())), 100);
    return items;
  }
  items() {
    const items = new ItemList();
    const discussion = this.attrs.discussion;
    const badges = discussion.badges().toArray();
    if (badges.length) {
      items.add('badges', m("ul", {
        className: "DiscussionHero-badges badges"
      }, listItems(badges)), 10);
    }
    items.add('title', m("h1", {
      className: "DiscussionHero-title"
    }, discussion.title()));
    return items;
  }
}
flarum.reg.add('core', 'forum/components/DiscussionHero', DiscussionHero);